import { Button, DatePicker, Form, Input, message, Modal, Radio, Select } from 'antd';
import dayjs from 'dayjs';
import { NotificationTemplateFilterFormFieldList, NotificationTemplateFilterFormValues, NotificationTemplateFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetDropDownData } from 'features/notification/use-cases/get-common-api-data';
import { useGetTemplate } from 'features/notification/use-cases/get-template';
import { useSendFirebaseNotification } from 'features/notification/use-cases/send-firebase-notifications-template';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { usePaginationParams } from 'hooks/use-pagination-params';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import { useNavigate } from 'react-router-dom';

const validateHtmlHyperlinks = (html: string): boolean => {
    if (!html) return true;
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const links = doc.querySelectorAll('a');
        for (let i = 0; i < links.length; i++) {
            const href = links[i].getAttribute('href');
            if (href && !/^https:\/\//i.test(href.trim())) {
                return false;
            }
        }
    } catch (e) {
        return true;
    }
    
return true;
};

const getInitialFilterValues: NotificationTemplateFilterFormValues = {
    Id: undefined,
    Title: undefined,
    TitleAr: undefined,
    ContentEn: undefined,
    ContentAr: undefined,
    Image: undefined,
    ImageUrl: undefined,
    AnnouncementType: undefined,
    templateId: null,
    TemplateName: undefined,
    ImageAr: undefined,
    RedirectionUrl: undefined,
    ImageUrlAr: undefined
};

export const SendFirebaseNotificationModal = ({ onClose, refetch, sessionId, allUser, setSelectedRowKeys }: { onClose: () => void; setSelectedRowKeys: any, showAddItemModal: boolean, refetch: () => void, sessionId: string, allUser: any }) => {

    const formName = 'send-firebase-notification-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<NotificationTemplateFilterFormValues>();
    const imageInputRef = useRef<HTMLInputElement>(null);
    const imageArInputRef = useRef<HTMLInputElement>(null);
    const { isLoading, mutate } = useSendFirebaseNotification();
    const [contentEn, setContentEn] = useState<string>("");
    const [contentAr, setContentAr] = useState<string>("");
    const [templateImage, setTemplateImage] = useState<File | any>(null);
    const deliverType = Form.useWatch("deliveryType", form);
    const quillEnRef = useRef<ReactQuill | null>(null);
    const quillArRef = useRef<ReactQuill | null>(null);

    useEffect(() => {
        const attachValidation = (quillRef: React.RefObject<ReactQuill | null>) => {
            if (!quillRef.current) return;
            const editor = quillRef.current.getEditor() as any;
            if (!editor || !editor.theme || !editor.theme.tooltip) return;

            const tooltip = editor.theme.tooltip;
            if ((tooltip as any)._hasHttpsValidation) return;

            const originalSave = tooltip.save;
            tooltip.save = function (this: any) {
                const value = this.textbox ? this.textbox.value?.trim() : '';
                if (this.root && this.root.getAttribute('data-mode') === 'link') {
                    if (value && !/^https:\/\//i.test(value)) {
                        message.error('Invalid hyperlink! Hyperlink must start with https://');
                        
return;
                    }
                }
                if (originalSave) {
                    originalSave.call(this);
                }
            };
            (tooltip as any)._hasHttpsValidation = true;
        };

        attachValidation(quillEnRef);
        attachValidation(quillArRef);
    });

    const handleProcedureContentChange = (
        content: React.SetStateAction<string>,
    ) => {

        setContentEn(content);
    };
    const [successModal, setSuccessModal] = useState(false);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [templateImageAr, setTemplateImageAr] = useState<File | null>(null);
    const [imagePreviewAr, setImagePreviewAr] = useState<string | null>(null);
    const [fileNameEn, setFileNameEn] = useState<string>('');
    const [fileNameAr, setFileNameAr] = useState<string>('');
    const title = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLE,
        form
    );
    const titlear = Form.useWatch(
        NotificationTemplateFilterFormFieldList.TITLEAR,
        form
    );
    const { params, updateParams } =
        usePaginationParams<NotificationTemplateFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
        });

    const [templateId, setTemplateId] = useState(0);
    const { data: templateData } = useGetTemplate(params, {
        retry: false,
        enabled: templateId > 0,
    });




    const handleProcedureContentArChange = (
        content: React.SetStateAction<string>,
        // delta: any,
        // source: any,
        // editor: any
    ) => {

        setContentAr(content);
    };
    const { data: notificationModalType } = useGetDropDownData({
        flag: "announcementtype",
        searchId: 0,
        SearchKey: ""
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: false
    });


    const { data: templateList } = useGetDropDownData({
        flag: "notificationtemplate",
        searchId: 0,
        SearchKey: ""
    }, {
        refetchOnWindowFocus: false,
        refetchOnMount: false
    });

    const handleClose = () => {
        onClose();

        form.resetFields();
        form.resetFields()
        setImagePreview(null);       // resets preview
        setTemplateImage(null);
        setTemplateImageAr(null);    // reset AR image
        setImagePreviewAr(null)
        setContentEn("");            // reset English editor
        setContentAr("");            // reset Arabic editor


    }
    useEffect(() => {
        form.resetFields();

        updateParams({ templateId: null });

        setContentEn("");
        setContentAr("");
        setImagePreview(null);
        setImagePreviewAr(null);

    }, [onClose]); //


    // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = e.target.files?.[0];
    //     if (file) {
    //         setTemplateImage(file);
    //         setImagePreview(URL.createObjectURL(file));
    //     }
    // };
    // AR image upload
    // const handleFileChangeAr = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = e.target.files?.[0];
    //     if (file) {
    //         setTemplateImageAr(file);
    //         setImagePreviewAr(URL.createObjectURL(file));
    //     }
    // };
    const handleFileChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const width = img.width;
            const height = img.height;

            const aspectRatio = width / height;
            const expectedRatio = 16 / 9;

            // Validate 16:9 aspect ratio
            const isValidRatio =
                Math.abs(aspectRatio - expectedRatio) < 0.01;

            if (!isValidRatio) {
                message.error(
                    `Invalid image dimensions: ${width}x${height}. Please upload a 16:9 image.`
                );

                // Clear input
                // if (imageInputRef.current) {
                //     imageInputRef.current.value = "";
                // }

                // Clear previous image
                setTemplateImage(null);
                setImagePreview(null);
                setFileNameEn("");

                URL.revokeObjectURL(objectUrl);

                return;
            }


            setTemplateImage(file);
            setImagePreview(objectUrl);
            setFileNameEn(file.name);

            message.success("Image uploaded successfully.");


        };

        img.onerror = () => {
            message.error("Invalid image file.");

            // if (imageInputRef.current) {
            //     imageInputRef.current.value = "";
            // }

            setTemplateImage(null);
            setImagePreview(null);
            setFileNameEn("");

            URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    };
    const handleFileChangeAr = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const width = img.width;
            const height = img.height;

            const aspectRatio = width / height;
            const expectedRatio = 16 / 9;

            // Validate 16:9 aspect ratio
            const isValidRatio =
                Math.abs(aspectRatio - expectedRatio) < 0.01;

            if (!isValidRatio) {
                message.error(
                    `Invalid image dimensions: ${width}x${height}. Please upload a 16:9 image.`
                );



                setFileNameAr("");
                setTemplateImageAr(null);
                setImagePreviewAr("");

                URL.revokeObjectURL(objectUrl);

                return;
            }

            // Valid 16:9 image
            setTemplateImageAr(file);
            setImagePreviewAr(objectUrl);
            setFileNameAr(file.name);

            message.success("Arabic image uploaded successfully.");
        };

        img.onerror = () => {
            message.error("Invalid image file.");


            setFileNameAr("");
            setTemplateImageAr(null);
            setImagePreviewAr("");

            URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    };
    const getFileNameFromUrl = (url: string) => {
        return url?.split('/').pop() || '';
    };
    const { t } = useTranslation();
    useEffect(() => {
        if (templateData?.items) {
            const tempData = templateData?.items[0] || null;
            form.setFieldsValue({
                Title: tempData?.Title,
                TitleAr: tempData?.TitleAr,
                AnnouncementType: tempData?.AnnouncementTypeId,
                ContentEn: tempData?.ContentEn,
                ContentAr: tempData?.ContentAr,
                ImageUrl: tempData?.ImageUrl,
                ImageUrlAr: tempData?.ArabicImage_Url
            });
            setFileNameAr(getFileNameFromUrl(tempData.ArabicImage_Url));
            setFileNameEn(getFileNameFromUrl(tempData.ImageUrl));
            setContentEn(tempData?.ContentEn || "");
            setContentAr(tempData?.ContentAr || "");
            setImagePreview(tempData?.ImageUrl || null);
            setImagePreviewAr(tempData?.ArabicImage_Url
                || null);
        }

    }, [templateData]);
    // const getInitialValues = {
    //     [NotificationTemplateFilterFormFieldList.ID]: undefined,
    //     [NotificationTemplateFilterFormFieldList.TITLE]: undefined,
    //     [NotificationTemplateFilterFormFieldList.TITLEAR]: undefined,
    //     [NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID]: undefined,
    //     [NotificationTemplateFilterFormFieldList.CONTENTEN]: undefined,
    //     [NotificationTemplateFilterFormFieldList.CONTENTAR]: undefined,
    //     [NotificationTemplateFilterFormFieldList.IMAGE]: undefined,
    //     [NotificationTemplateFilterFormFieldList.IMAGEURL]: undefined,
    //     [NotificationTemplateFilterFormFieldList.ImageUrlAr]: undefined

    // };
    const navigate = useNavigate();
    const hanldeSuccess = () => {
        handleClose();
        refetch();
        message.success("Push notification recipients inserted successfully.");
        sessionStorage.removeItem("sessionId");
        setSelectedRowKeys([]);
        navigate("/notification/customers-list?tab=1", {
            replace: true,
        });
    };
    const handleUpdate = (formData: any) => {
        formData[NotificationTemplateFilterFormFieldList.SESSIONID] = sessionId;
        // formData[NotificationTemplateFilterFormFieldList.ISINSTANT] = (formData[NotificationTemplateFilterFormFieldList.DELIVERYTYPE] == undefined) ? true : false;
        formData[NotificationTemplateFilterFormFieldList.ISINSTANT] = Number(formData[NotificationTemplateFilterFormFieldList.DELIVERYTYPE]) === 1 || formData[NotificationTemplateFilterFormFieldList.DELIVERYTYPE] === undefined; formData[NotificationTemplateFilterFormFieldList.TEMPLATEID] = templateId;

        formData[NotificationTemplateFilterFormFieldList.TEMPLATEID] = templateId;
        // if (deliverType == 2) {
        //     formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE] = formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE]?.format("YYYY-MM-DD HH:mm");
        //     // formData[NotificationTemplateFilterFormFieldList.SCHEDULETIME] = formData[NotificationTemplateFilterFormFieldList.SCHEDULETIME]?.format("HH:mm:ss");
        // }

        if (deliverType == 2 && formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE]) {
            formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE] = formData[NotificationTemplateFilterFormFieldList.SCHEDULEDATE].toDate().toUTCString();
        }

        // formData[NotificationTemplateFilterFormFieldList.IMAGE] = templateImage;
        if (templateImage) {
            formData[NotificationTemplateFilterFormFieldList.IMAGE] = templateImage;
        }

        if (templateImageAr) {
            formData[NotificationTemplateFilterFormFieldList.IMAGEAR] = templateImageAr;
        }
        formData.flag = allUser
        mutate(formData, { onSuccess: hanldeSuccess });
    };

    return (
        <>
            <div className='popup template_modal'>
                <div className='modal_head'>
                    <h4> Send a New Firebase Notification</h4>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                </div>
                <div className='modal_body' >
                    <Form<NotificationTemplateFilterFormValues>
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={{
                            // FIX: Use the enum key here
                            [NotificationTemplateFilterFormFieldList.DELIVERYTYPE]: 1,
                            ...getInitialFilterValues,
                        }}
                        onFinish={handleUpdate}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);

                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                        requiredMark={true}
                        scrollToFirstError
                    >



                        <div className='templte_review'>
                            <div style={{ width: '50%' }}>
                                <FormSectionsSeparator title={"Notification Content"} >
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label="Select Template"
                                        name={NotificationTemplateFilterFormFieldList.TEMPLATENAME}
                                    >
                                        <Select placeholder="Select Type"
                                            style={{ width: "100%" }}
                                            options={templateList?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                            onChange={(value: number) => {
                                                setTemplateId(value);
                                                updateParams({
                                                    templateId: value,
                                                });
                                            }}
                                            allowClear

                                        >
                                        </Select>
                                    </Form.Item>
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label="Notification Type"
                                        name={NotificationTemplateFilterFormFieldList.ANNOUNCEMENTTYPEID}
                                    >
                                        <Select placeholder="Select Type"
                                            style={{ width: "100%" }}
                                            options={notificationModalType?.notificationDropDownList?.map((res: any) => ({
                                                label: res.title,
                                                value: res.id
                                            }))}
                                            disabled
                                            allowClear>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item<NotificationTemplateFilterFormFieldList>
                                        label={"English Notification Title"}
                                        name={NotificationTemplateFilterFormFieldList.TITLE}
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: t('validateMessages.custom.nomsg'),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={"Enter Notification Title"}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Arabic Notification Title"
                                        name={NotificationTemplateFilterFormFieldList.TITLEAR}
                                        style={{ direction: "rtl", textAlign: "right" }}
                                        rules={[{ required: true, message: t('validateMessages.custom.nomsg') }]}
                                    >
                                        <Input
                                            placeholder="Enter Notification TitleAr"
                                            style={{ direction: "rtl", textAlign: "right" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="English Message"
                                        className="english-editor"
                                        name={NotificationTemplateFilterFormFieldList.CONTENTEN}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "Message is required" },
                                            {
                                                validator: (_, value) => {
                                                    if (value && !validateHtmlHyperlinks(value)) {
                                                        return Promise.reject("Hyperlink must start with https://");
                                                    }
                                                    
return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <ReactQuill
                                            ref={quillEnRef}
                                            className="editor-small cstm_editor "
                                            theme="snow"
                                            value={contentEn || ""}
                                            onChange={handleProcedureContentChange}

                                            modules={SendFirebaseNotificationModal.modules}
                                            formats={SendFirebaseNotificationModal.formats}
                                            placeholder="Enter your message here..."
                                        // dangerouslySetInnerHTML={{ __html: code }}
                                        // readOnly={!edit}
                                        />
                                    </Form.Item>
                                    {/* <Space></Space> */}
                                    <Form.Item
                                        className="arabic-editor"
                                        label="Arabic Message"
                                        style={{ direction: "rtl", textAlign: "right" }}

                                        name={NotificationTemplateFilterFormFieldList.CONTENTAR}
                                        valuePropName="value"
                                        getValueFromEvent={(value) => value}
                                        rules={[
                                            { required: true, message: "MessageAr is required" },
                                            {
                                                validator: (_, value) => {
                                                    if (value && !validateHtmlHyperlinks(value)) {
                                                        return Promise.reject("Hyperlink must start with https://");
                                                    }
                                                    
return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <ReactQuill
                                            ref={quillArRef}
                                            className="editor-small cstm_editor "
                                            theme="snow"
                                            value={contentAr || ""}
                                            onChange={handleProcedureContentArChange}
                                            modules={SendFirebaseNotificationModal.modules}
                                            formats={SendFirebaseNotificationModal.formats}
                                            placeholder="Enter your message here..."
                                        />
                                    </Form.Item>
                                    <Form.Item label="English Image">
                                        <div
                                            onClick={() => imageInputRef.current?.click()}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '32px',
                                                border: '1px solid #bfbfbf',
                                                borderRadius: '6px',
                                                background: '#fff',
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                padding: '0 4px',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {/* Hidden file input */}
                                            <input
                                                id="english-image"
                                                type="file"
                                                onChange={handleFileChange}
                                                accept=".png,.jpg,.jpeg"
                                                ref={imageInputRef}
                                                style={{ display: 'none' }}
                                            />

                                            {/* Choose File Button */}
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '24px',
                                                    padding: '0 10px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    background: '#f5f5f5',
                                                    color: '#333',
                                                    fontSize: '13px',
                                                    whiteSpace: 'nowrap',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                Choose file
                                            </span>

                                            {/* Selected file name */}
                                            <span
                                                style={{
                                                    marginLeft: '8px',
                                                    fontSize: '13px',
                                                    color: fileNameEn ? '#333' : '#999',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {fileNameEn || 'No file chosen'}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 5,
                                                fontSize: 12,
                                                color: '#888',
                                            }}
                                        >
                                            Recommended size:{' '}
                                            <strong>1920 × 1080 px (16:9)</strong>
                                        </div>
                                    </Form.Item>

                                    <Form.Item label="Arabic Image">
                                        <div
                                            onClick={() => imageArInputRef.current?.click()}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                width: '100%',
                                                height: '32px',
                                                border: '1px solid #bfbfbf',
                                                borderRadius: '6px',
                                                background: '#fff',
                                                cursor: 'pointer',
                                                overflow: 'hidden',
                                                padding: '0 4px',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            {/* Hidden file input */}
                                            <input
                                                id="arabic-image"
                                                type="file"
                                                onChange={handleFileChangeAr}
                                                accept=".png,.jpg,.jpeg"
                                                ref={imageArInputRef}
                                                style={{ display: 'none' }}
                                            />

                                            {/* Choose File Button */}
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: '24px',
                                                    padding: '0 10px',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '4px',
                                                    background: '#f5f5f5',
                                                    color: '#333',
                                                    fontSize: '13px',
                                                    whiteSpace: 'nowrap',
                                                    flexShrink: 0,
                                                }}
                                            >
                                                Choose file
                                            </span>

                                            {/* Selected file name */}
                                            <span
                                                style={{
                                                    marginLeft: '8px',
                                                    fontSize: '13px',
                                                    color: fileNameAr ? '#333' : '#999',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                {fileNameAr || 'No file chosen'}
                                            </span>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: 5,
                                                fontSize: 12,
                                                color: '#888',
                                            }}
                                        >
                                            Recommended size:{' '}
                                            <strong>1920 × 1080 px (16:9)</strong>
                                        </div>
                                    </Form.Item>



                                    <Form.Item
                                        label="Redirection Link"
                                        name={NotificationTemplateFilterFormFieldList.RedirectionUrl}
                                        rules={[
                                            {
                                                validator: (_, value) => {
                                                    if (value && !/^https:\/\//i.test(value.trim())) {
                                                        return Promise.reject("Hyperlink must start with https://");
                                                    }
                                                    
return Promise.resolve();
                                                }
                                            }
                                        ]}
                                    >
                                        <Input placeholder="https://example.com" />
                                    </Form.Item>
                                </FormSectionsSeparator>

                                <FormSectionsSeparator title={"Delivery Setting"}>


                                    {/* Delivery Type */}
                                    <Form.Item
                                        label="Delivery Type"
                                        name={NotificationTemplateFilterFormFieldList.DELIVERYTYPE}
                                    >
                                        <Radio.Group
                                            onChange={(e) => {
                                                const selectedValue = Number(e.target.value);

                                                if (selectedValue === 1) {
                                                    form.setFieldsValue({
                                                        [NotificationTemplateFilterFormFieldList.SCHEDULEDATE]: null,
                                                    });
                                                }
                                            }}
                                        >
                                            <Radio value={1}>Instant Notification</Radio>
                                            <Radio value={2}>Schedule Notification</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {deliverType === 2 && (
                                        <Form.Item
                                            label="Schedule Date"
                                            name={NotificationTemplateFilterFormFieldList.SCHEDULEDATE}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please select date",
                                                },
                                                {
                                                    validator: (_, value) => {
                                                        if (!value) {
                                                            return Promise.resolve();
                                                        }

                                                        // Check whether selected date/time is in the past
                                                        if (value.isBefore(dayjs(), "minute")) {
                                                            return Promise.reject(
                                                                new Error(
                                                                    "Please select a current or future date and time."
                                                                )
                                                            );
                                                        }

                                                        return Promise.resolve();
                                                    },
                                                },
                                            ]}
                                        >
                                            <DatePicker
                                                showTime
                                                inputReadOnly
                                                style={{ width: "100%" }}
                                                format="DD/MM/YYYY HH:mm"
                                                placeholder="DD/MM/YYYY HH:mm"

                                                // Disable previous dates
                                                disabledDate={(current) => {
                                                    return current && current.isBefore(dayjs(), "day");
                                                }}

                                                // Disable previous time for today
                                                disabledTime={(current) => {
                                                    if (!current || !current.isSame(dayjs(), "day")) {
                                                        return {};
                                                    }

                                                    const now = dayjs();

                                                    return {
                                                        // Disable previous hours
                                                        disabledHours: () =>
                                                            Array.from(
                                                                { length: now.hour() },
                                                                (_, i) => i
                                                            ),

                                                        // Disable previous minutes in current hour
                                                        disabledMinutes: (selectedHour) =>
                                                            selectedHour === now.hour()
                                                                ? Array.from(
                                                                    { length: now.minute() },
                                                                    (_, i) => i
                                                                )
                                                                : [],

                                                        // Disable previous seconds in current minute
                                                        disabledSeconds: (
                                                            selectedHour,
                                                            selectedMinute
                                                        ) =>
                                                            selectedHour === now.hour() &&
                                                                selectedMinute === now.minute()
                                                                ? Array.from(
                                                                    { length: now.second() },
                                                                    (_, i) => i
                                                                )
                                                                : [],
                                                    };
                                                }}

                                                onChange={(value) => {
                                                    if (!value) {
                                                        return;
                                                    }

                                                    if (value.isBefore(dayjs(), "minute")) {
                                                        message.error(
                                                            "Please select a current or future date and time."
                                                        );

                                                        return;
                                                    }


                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                </FormSectionsSeparator>
                            </div>
                            <Modal
                                open={successModal}
                                footer={null}
                                closable={true}
                                onCancel={() => {
                                    setSuccessModal(false);
                                    handleClose();
                                }}
                                centered
                                width={400}
                            >
                                <div className="success-modal-container">

                                    <div className="success-circle">
                                        <span className="success-icon">✔</span>
                                    </div>

                                    <h2 className="success-title">
                                        Saved!
                                    </h2>

                                    <p className="success-text">
                                        Notification has been sent successfully.

                                    </p>
                                </div>
                            </Modal>
                            <Form.Item className='preview_dtl'>
                                <div
                                >
                                    <div
                                        style={{
                                            background: '#f0f0f0',
                                            borderRadius: 4,
                                            padding: 16,

                                        }} >
                                        <h4>Your Notification Look Like</h4>
                                        <p>View how your template will appear before final use</p>
                                        <div className='notify_preview'>
                                            <div className='en'>
                                                <h3 >English Preview</h3>
                                                <div className="eng_prviw">
                                                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                                                        {title || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentEn || 'No description here'
                                                        }}
                                                    />
                                                    {imagePreview && (
                                                        <div className='img_box'>
                                                            <img
                                                                src={imagePreview}
                                                                alt="Preview EN"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}

                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='ar'>
                                                <h3 >Arabic Preview</h3>
                                                <div className='eng_prviw'>
                                                    <div style={{ fontWeight: 600, marginBottom: 8 }}>
                                                        {titlear || 'Notification Title'}
                                                    </div>
                                                    <div
                                                        style={{ color: '#555' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html: contentAr || 'No description here'
                                                        }}
                                                    />
                                                    <div className='img_box'>
                                                        {imagePreviewAr && (
                                                            <img
                                                                src={imagePreviewAr}
                                                                alt="Preview AR"
                                                                style={{
                                                                    width: '130px',
                                                                    marginTop: 10,
                                                                    borderRadius: 6
                                                                }}
                                                            />

                                                        )}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form.Item>
                        </div>
                        <div className='form-button'>
                            <Button htmlType='submit' className='btn' type='primary'>Send Notification</Button>
                        </div>
                    </Form>
                </div>
            </div >
        </>
    )
};
SendFirebaseNotificationModal.modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }], // Select dropdown for heading
        [{ 'font': [] }], // Select dropdown for font size
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'align': [] }], // Select dropdown for text alignment
        [{ 'color': [] }, { 'background': [] }], // Select dropdowns for text and background color
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link'],
        ['clean']
    ],
    clipboard: {
        matchVisual: true,
    }
};
SendFirebaseNotificationModal.formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'color', 'background'
];